export default __webpack_public_path__ + "static/media/anthe-map.ab7eec13.png";